import * as React from 'react';

import { INTERNAL_DATA_LAKE_ID } from 'data-lake/preview/storage-types/internal/Constants';

import PreviewLakeLogsButton from './PreviewLakeLogsButton';

type Props = Omit<React.ComponentProps<typeof PreviewLakeLogsButton>, 'urlParams' | 'dataLakeId'> & {
  streamId: string;
};

const PreviewInternalLakeLogsButton = ({ bsStyle, bsSize, target, children, streamId, onClick }: Props) => (
  <PreviewLakeLogsButton
    urlParams={`streams=${streamId}`}
    bsStyle={bsStyle}
    bsSize={bsSize}
    target={target}
    dataLakeId={INTERNAL_DATA_LAKE_ID}
    onClick={onClick}>
    {children}
  </PreviewLakeLogsButton>
);

export default PreviewInternalLakeLogsButton;
